export function safeStringEncode(str: string) {
  return btoa(str);
}
export function safeStringDecode(str: string) {
  return atob(str);
}
